export const getSelectedKey = ({ pathname }) => {
      if (pathname.includes("/members/") && /\d/.test(pathname)) {
            return ['13'];
      }
      if (pathname.includes("/transactions/")) {
            return ['22'];
      }
      if (pathname.includes("/bet_detail/") && /\d/.test(pathname)) {
            return ['16'];
      }
      if (pathname.includes("/2d_detail/") && /\d/.test(pathname)) {
            return ['16'];
      }
      if (pathname.includes("/3d_detail/") && /\d/.test(pathname)) {
            return ['16'];
      }
      if (pathname.includes("/4d_detail/") && /\d/.test(pathname)) {
            return ['16'];
      }
      switch (pathname) {
            case "/":
                  return ['22'];
            case "/lsport":
                  return ['2'];
            case "/leagues":
                  return ['3'];
            case "/teams":
                  return ['4'];
            case "/members/new":
                  return ['10'];
            case "/members":
                  return ['13'];
            case "/collection_report":
                  return ['16'];
            case "/member_report":
                  return ['18'];
            case "/account":
                  return ['20'];
            case "/payments":
                  return ['23'];
            case "/deposits":
                  return ['80'];
            case "/withdraws":
                  return ['81'];
            case "/2d_report":
                  return ['19'];
            case "/3d_report":
                  return ['21'];
            case "/4d_report":
                  return ['24'];
            default:
                  return ['2'];
      }
}